/**
 * Safe wrappers around localStorage / sessionStorage.
 * Never throw — return defaults on failure.
 */

function safeGet(storage: Storage, key: string): string | null {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(storage: Storage, key: string, value: string): void {
  try {
    storage.setItem(key, value);
  } catch {
    // silently fail
  }
}

function safeRemove(storage: Storage, key: string): void {
  try {
    storage.removeItem(key);
  } catch {
    // silently fail
  }
}

export const safeLocalGet = (key: string) => safeGet(localStorage, key);
export const safeLocalSet = (key: string, value: string) => safeSet(localStorage, key, value);
export const safeLocalRemove = (key: string) => safeRemove(localStorage, key);

export const safeSessionGet = (key: string) => safeGet(sessionStorage, key);
export const safeSessionSet = (key: string, value: string) => safeSet(sessionStorage, key, value);
export const safeSessionRemove = (key: string) => safeRemove(sessionStorage, key);
